export const getAPIUrl = () => {
  const { hostname } = window.location;
  // const siteName = `${window.location.origin}`;
  if (hostname.includes('localhost')) {
    // return 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0'; // dev;
    // return 'https://5ob779krjh.execute-api.us-east-1.amazonaws.com/v0'  // qa;
    return process.env.REACT_APP_LAMBDA_URI;
    // return 'https://5n1g4utk0l.execute-api.us-east-1.amazonaws.com/DEV';
    // 'https://jsonplaceholder.typicode.com'
  }
  return process.env.REACT_APP_LAMBDA_URI;

};

// export default getAPIUrl;

export const getAPIUrl_solveorder = () => {
  const { hostname } = window.location;
  // const siteName = `${window.location.origin}`;
  if (hostname.includes('localhost')) {
    // return 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0'; // dev;
    // return 'https://5ob779krjh.execute-api.us-east-1.amazonaws.com/v0'  // qa;
    return process.env.REACT_APP_LAMBDA_URI_SOLVE_ORDER;
    // return 'https://5n1g4utk0l.execute-api.us-east-1.amazonaws.com/DEV';
    // 'https://jsonplaceholder.typicode.com'
  }
  return process.env.REACT_APP_LAMBDA_URI_SOLVE_ORDER;
};

// export const getAPIUrl_solveorder;
